import axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'
import { getWithRedirect, postWithRedirect } from 'utils/axios'
import {
  IEntity,
  PutEntityAttribute,
  PutEntityAttributeResponse
} from 'types/GlobalEntities'
import { IUnderlyingDataResponse } from 'types/GlobalWidget'
import { TGlobalFilterApiInput } from 'types/GlobalGlobalFilter'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const ENTITY_URL = `${BASE_URL}v1/entities`
const ENTITY_ATTRIBUTES_URL = `${BASE_URL}v1/entity-attributes`

export async function getAll() {
  return getWithRedirect<IEntity[]>(ENTITY_URL)
}

export async function put(
  entityId: string,
  entityAttributes: PutEntityAttribute[]
) {
  return axios.put<{ data: PutEntityAttributeResponse[] }>(
    `${ENTITY_ATTRIBUTES_URL}/${entityId}`,
    { data: entityAttributes },
    parseAuthenticationHeader()
  )
}

export interface IPreviewQueryParams {
  slices?: string
  calculation?: string
}

function parsePreviewQueryParams(
  queryParams: IPreviewQueryParams | null,
  globalFilter: TGlobalFilterApiInput
): IPreviewQueryParams & { global_filter: TGlobalFilterApiInput } {
  return {
    ...(queryParams ?? {}),
    global_filter: globalFilter
  }
}

export async function getPreview(
  id: string,
  queryParams: IPreviewQueryParams | null,
  globalFilter: TGlobalFilterApiInput
) {
  const parsedQueryParams = parsePreviewQueryParams(queryParams, globalFilter)

  return postWithRedirect<IUnderlyingDataResponse>(
    `${ENTITY_URL}/${id}/preview`,
    { data: parsedQueryParams }
  )
}
